import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  ISO8601DateTime: { input: any; output: any };
  JSON: { input: any; output: any };
};

export type Friendship = {
  __typename?: 'Friendship';
  createFriendship: Friendship;
  createdAt: Scalars['ISO8601DateTime']['output'];
  friend: User;
  friendId: Scalars['Int']['output'];
  friendships: Array<Friendship>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type FriendshipCreateFriendshipArgs = {
  token: Scalars['String']['input'];
};

export type FriendshipFriendshipsArgs = {
  friendId?: InputMaybe<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** An example field added by the generator */
  testField: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  me?: Maybe<User>;
  share?: Maybe<Share>;
  shares: Array<Share>;
  /** An example field added by the generator */
  testField?: Maybe<Scalars['String']['output']>;
  uploads: UploadConnection;
};

export type QueryShareArgs = {
  id: Scalars['ID']['input'];
};

export type QuerySharesArgs = {
  friendshipId?: InputMaybe<Scalars['ID']['input']>;
  uploadId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  friendshipId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type Share = {
  __typename?: 'Share';
  createdAt: Scalars['ISO8601DateTime']['output'];
  friendId: Scalars['ID']['output'];
  friendship: Friendship;
  friendshipId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  shares: Array<Share>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  upload: Upload;
  uploadId: Scalars['Int']['output'];
};

export type ShareSharesArgs = {
  friendshipId?: InputMaybe<Scalars['ID']['input']>;
  uploadId?: InputMaybe<Scalars['ID']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  uploadCreated?: Maybe<Upload>;
  uploadUpdated: Upload;
};

export type SubscriptionUploadUpdatedArgs = {
  id: Scalars['ID']['input'];
};

export type Upload = {
  __typename?: 'Upload';
  byteSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  orientation?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  ready: Scalars['Boolean']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploads: Array<Upload>;
  url: Scalars['String']['output'];
  user: User;
  userId: Scalars['Int']['output'];
};

export type UploadUploadsArgs = {
  friendshipId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Upload. */
export type UploadConnection = {
  __typename?: 'UploadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UploadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Upload>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Total number of uploads */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UploadEdge = {
  __typename?: 'UploadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Upload>;
};

/** A registered user in the system */
export type User = {
  __typename?: 'User';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  passwordDigest?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ShareByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ShareByIdQuery = {
  __typename?: 'Query';
  share?: {
    __typename?: 'Share';
    id: string;
    upload: {
      __typename?: 'Upload';
      byteSize: number;
      contentType: string;
      createdAt: any;
      description?: string | null;
      filename: string;
      id: string;
      metadata?: any | null;
      orientation?: string | null;
      previewUrl?: string | null;
      ready: boolean;
      updatedAt: any;
      url: string;
      userId: number;
      user: {
        __typename?: 'User';
        id: string;
        createdAt: any;
        email?: string | null;
        name?: string | null;
        passwordDigest?: string | null;
        updatedAt: any;
      };
    };
  } | null;
};

export type FriendshipFieldsFragment = {
  __typename?: 'Friendship';
  createdAt: any;
  friendId: number;
  id: string;
  updatedAt: any;
  userId: number;
  friend: { __typename?: 'User'; id: string };
  user: { __typename?: 'User'; id: string };
};

export type MutationFieldsFragment = {
  __typename?: 'Mutation';
  testField: string;
};

export type PageInfoFieldsFragment = {
  __typename?: 'PageInfo';
  endCursor?: string | null;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  startCursor?: string | null;
};

export type ShareFieldsFragment = {
  __typename?: 'Share';
  createdAt: any;
  friendId: string;
  friendshipId: number;
  id: string;
  updatedAt: any;
  uploadId: number;
  friendship: { __typename?: 'Friendship'; id: string };
  upload: { __typename?: 'Upload'; id: string };
};

export type UploadEdgeFieldsFragment = {
  __typename?: 'UploadEdge';
  cursor: string;
  node?: { __typename?: 'Upload'; id: string } | null;
};

export type UploadFieldsFragment = {
  __typename?: 'Upload';
  byteSize: number;
  contentType: string;
  createdAt: any;
  description?: string | null;
  filename: string;
  id: string;
  metadata?: any | null;
  orientation?: string | null;
  previewUrl?: string | null;
  ready: boolean;
  updatedAt: any;
  url: string;
  userId: number;
  user: { __typename?: 'User'; id: string };
};

export type UserFieldsFragment = {
  __typename?: 'User';
  createdAt: any;
  email?: string | null;
  id: string;
  name?: string | null;
  passwordDigest?: string | null;
  updatedAt: any;
};

export type UploadCreatedSubscriptionVariables = Exact<{
  [key: string]: never;
}>;

export type UploadCreatedSubscription = {
  __typename?: 'Subscription';
  uploadCreated?: {
    __typename?: 'Upload';
    id: string;
    user: { __typename?: 'User'; id: string; email?: string | null };
  } | null;
};

export type UploadUpdatedSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type UploadUpdatedSubscription = {
  __typename?: 'Subscription';
  uploadUpdated: {
    __typename?: 'Upload';
    id: string;
    orientation?: string | null;
    user: { __typename?: 'User'; id: string; email?: string | null };
  };
};

export const FriendshipFieldsFragmentDoc = gql`
  fragment FriendshipFields on Friendship {
    createdAt
    friend {
      id
    }
    friendId
    id
    updatedAt
    user {
      id
    }
    userId
  }
`;
export const MutationFieldsFragmentDoc = gql`
  fragment MutationFields on Mutation {
    testField
  }
`;
export const PageInfoFieldsFragmentDoc = gql`
  fragment PageInfoFields on PageInfo {
    endCursor
    hasNextPage
    hasPreviousPage
    startCursor
  }
`;
export const ShareFieldsFragmentDoc = gql`
  fragment ShareFields on Share {
    createdAt
    friendId
    friendship {
      id
    }
    friendshipId
    id
    updatedAt
    upload {
      id
    }
    uploadId
  }
`;
export const UploadEdgeFieldsFragmentDoc = gql`
  fragment UploadEdgeFields on UploadEdge {
    cursor
    node {
      id
    }
  }
`;
export const UploadFieldsFragmentDoc = gql`
  fragment UploadFields on Upload {
    byteSize
    contentType
    createdAt
    description
    filename
    id
    metadata
    orientation
    previewUrl
    ready
    updatedAt
    url
    user {
      id
    }
    userId
  }
`;
export const UserFieldsFragmentDoc = gql`
  fragment UserFields on User {
    createdAt
    email
    id
    name
    passwordDigest
    updatedAt
  }
`;
export const ShareByIdDocument = gql`
  query ShareById($id: ID!) {
    share(id: $id) {
      id
      upload {
        ...UploadFields
        user {
          ...UserFields
        }
      }
    }
  }
  ${UploadFieldsFragmentDoc}
  ${UserFieldsFragmentDoc}
`;

export function useShareByIdQuery(
  options: Omit<Urql.UseQueryArgs<ShareByIdQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ShareByIdQuery, ShareByIdQueryVariables>({
    query: ShareByIdDocument,
    ...options,
  });
}
export const UploadCreatedDocument = gql`
  subscription UploadCreated {
    uploadCreated {
      id
      user {
        id
        email
      }
    }
  }
`;

export function useUploadCreatedSubscription<TData = UploadCreatedSubscription>(
  options?: Omit<
    Urql.UseSubscriptionArgs<UploadCreatedSubscriptionVariables>,
    'query'
  >,
  handler?: Urql.SubscriptionHandler<UploadCreatedSubscription, TData>,
) {
  return Urql.useSubscription<
    UploadCreatedSubscription,
    TData,
    UploadCreatedSubscriptionVariables
  >({ query: UploadCreatedDocument, ...options }, handler);
}
export const UploadUpdatedDocument = gql`
  subscription UploadUpdated($id: ID!) {
    uploadUpdated(id: $id) {
      id
      orientation
      user {
        id
        email
      }
    }
  }
`;

export function useUploadUpdatedSubscription<TData = UploadUpdatedSubscription>(
  options: Omit<
    Urql.UseSubscriptionArgs<UploadUpdatedSubscriptionVariables>,
    'query'
  >,
  handler?: Urql.SubscriptionHandler<UploadUpdatedSubscription, TData>,
) {
  return Urql.useSubscription<
    UploadUpdatedSubscription,
    TData,
    UploadUpdatedSubscriptionVariables
  >({ query: UploadUpdatedDocument, ...options }, handler);
}
